export default function Footer() {
  return (
    <p
      style={{
        backgroundColor: "black",
        color: "tomato",
        position: "fixed",
        bottom: "0px",
        width: "100vw",
        fontFamily: "fantasy",
        padding: "10px",
        fontSize: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      &copy; created by replyr
    </p>
  );
}
